import { useAuth0 } from '@auth0/auth0-react'
import { createFileRoute } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { MillboxAiChatTransport } from '@/components/screens/ai-chat/ai-chat-transport'
import { AIChatWorkspace } from '@/components/screens/ai-chat/ai-chat-workspace'
import { envVariables } from '@/lib/env'

export const Route = createFileRoute('/t/$tenant_id/ai_chat')({
  component: Page,
})

function Page() {
  const { tenant_id: tenantId } = Route.useParams()

  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <AiChatContainer tenantId={tenantId} />
    </div>
  )
}

// GraphQL を使わない画面だが、他の画面と同じく「外部への口（env・認証・transport）は
// コンテナ側で閉じ、画面コンポーネントは props 駆動」を保つためのコンテナ
function AiChatContainer({ tenantId }: { tenantId: string }) {
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0()

  // Apollo の createAuthLink・AuthenticatedApolloProvider と同じ認証方式（idToken.__raw）に揃える。
  // MillboxAiChatTransport は React hook を呼べないクラスのため、トークン取得は関数として渡す
  const getIdToken = useCallback(async (): Promise<string | null> => {
    try {
      await getAccessTokenSilently()
      const claims = await getIdTokenClaims()
      return claims?.__raw ?? null
    } catch {
      return null
    }
  }, [getAccessTokenSilently, getIdTokenClaims])

  // useChat は transport を遅延参照するので作り直しても再購読はされないが、
  // 毎レンダー新しい fetch クロージャを作らないよう useMemo で固定しておく
  const transport = useMemo(
    () => new MillboxAiChatTransport({ apiHost: envVariables.API_HOST, tenantId, getIdToken }),
    [tenantId, getIdToken],
  )

  return <AIChatWorkspace transport={transport} />
}
